// import '@babel/polyfill'  // this was not commented until March 26 2021
// import 'mutationobserver-shim'

import Vue from 'vue';

//import Vuex from 'vuex'
//Vue.use(Vuex);  // seems like you should NOT do this here...

// ====== CSS / SCSS ==========

import './css/supplios-ag-grid.scss';
import './css/supplios-vendor-css.scss';
import './css/supplios-theme.scss';
import 'devextreme/dist/css/dx.light.css';

// import './css/more-css.scss'
import { HelpscoutHelper, helpscoutBeaconMixin } from './js/helpscout';
import { splUtilsMixin } from './js/custom-vue-mixins'; // has $devlog, $splData, etc.
import posthogMixin from './js/posthog_mixin';
import { nanoid } from 'nanoid'; // we make this available globally on the js bundle for front-end helpers outside of vue

// ======= BootstrapVue and its IconsPlugin (these are plugins), then register to use it with Vue.use()
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
let bsVueConfig = {
  BToast: {
    toaster: 'b-toaster-top-right',
    autoHideDelay: 2500,
    variant: 'success',
    toastClass: null,
    headerClass: null,
    bodyClass: null,
  },
};
Vue.use(BootstrapVue, bsVueConfig);
Vue.use(IconsPlugin);

// vue-i18n -- for internationalization / translations
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// then we also import & export our setupVueI18n function to create the i18n instance with our common messages
import setupVueI18n from './localization/setupI18n';  // we just export it again as part of the bundle then call this on frontend
import splI18nMixin from './localization/globalMixin';  // global mixin for i18n things
Vue.mixin(splI18nMixin); // adds $windowLocale and $splLocale (computed properties)

// PrimeVue - this is only the core stuff -- components are separate, and can be used one-by-one
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
// also need CSS - maybe just import into one of your SCSS files
//primevue/resources/themes/saga-blue/theme.css       //theme
//primevue/resources/primevue.min.css                 //core css
//primeicons/primeicons.css                           //icons
// PrimeVue components - can just import here... if many, maybe separate out
import MultiSelect from 'primevue/multiselect';
//import OverlayPanel from 'primevue/overlaypanel';  // import in SFC instead
//import Calendar from 'primevue/calendar';
Vue.component('MultiSelect', MultiSelect);
// Vue.component('OverlayPanel', OverlayPanel);  // import in SFC instead
//Vue.component('Calendar', Calendar);  // you can import in SFC instead

// ======= GLOBAL VUE MIXINS -- use carefully because it will include this in ALL Vue instances
// you're using this to get stuff from Django base template and inject into each Vue instance
// const helpscoutHelper = new HelpscoutHelper();  // instantiate on client-side instead... just do it in your spl-base template
Vue.mixin(helpscoutBeaconMixin); // must have instance of your HelpscoutHelper on winow.helpscoutHelper
Vue.mixin(splUtilsMixin); // adds $splData (computed property) and $devlog (method)
Vue.mixin(posthogMixin); // adds $posthog (computed property) and maybe some methods

// ======= 3rd party JS libraries (only if you need them everywhere... otherwise import into components)
// axios, lodash

// ====== AG-GRID =========
//import {AgGridVue} from "ag-grid-vue"   // import in component when used instead
import 'ag-grid-enterprise'; // you should probably be more specific about what you're importing here...
import { LicenseManager } from 'ag-grid-enterprise';
import { agGridLicenseKey } from './constants.js';
LicenseManager.setLicenseKey(agGridLicenseKey);

// ===== Cleave.js ======
import Cleave from 'cleave.js';
Vue.directive('cleave', {
  inserted: (el, binding) => {
    el.cleave = new Cleave(el, binding.value || {});
  },
  update: (el) => {
    const event = new Event('input', { bubbles: true });
    setTimeout(function () {
      el.value = el.cleave.properties.result;
      el.dispatchEvent(event);
    }, 100);
  },
});

// =====  vue-toastification  =====
import Toast from 'vue-toastification';
// Importing CSS for vue-toastification in supplios-vendor-css.scss
//const myToastContainer = document.querySelector('#app');
//const myToastContainer = document.body;
const toastificationOptions = {
  // set custom defaults for vue-toastification
  //container: myToastContainer,  // not needed... default should be a div that is direct child of document.body
  position: 'top-right',
  timeout: 3000,
  toastClassName: 'spl-toastification',
  transition: 'Vue-Toastification__fade',
  //transition: 'Vue-Toastification__slideBlurred',
};
//import "vue-toastification/dist/index.css";
import './css/vue-toastification.scss';
Vue.use(Toast, toastificationOptions);
//Vue.use(Toast)

// ===== vue-tooltip  (used for vue-mention, maybe others)  =======
import VTooltip from 'v-tooltip';
const vueTooltipOptions = {
  // set custom things for vue-tooltip, like custom styles
  // more details:  https://github.com/Akryum/v-tooltip#global-options
};
Vue.use(VTooltip, vueTooltipOptions);

// ===== YOUR COMPONENTS ======
import * as components from './global-components.js';

if (typeof Vue !== 'undefined') {
  for (const name in components) {
    Vue.component(name, components[name]);
  }
}

// IMPORT ASYNC COMPONENTS FOR CODE SPLITTING
Vue.component('TagManager', () => import('./components/taxonomy/tags/TagManagerOLD.vue'));
Vue.component(
  'ScorecardSelector',
  // A dynamic import returns a Promise.
  () => import('./components/demo-workflow/ScorecardSelector.vue')
);
Vue.component('SmartFormInternalManager', () => import('./components/smartforms/SmartFormInternalManager.vue'));
Vue.component('SmartFormJsonBuilder', () => import('./components/smartforms/SmartFormJsonBuilder.vue'));
Vue.component('HqBulkUpload', () => import('./components/hq/HqBulkUpload.vue'));
Vue.component('HqTenantDataExport', () => import('./components/hq/HqTenantDataExport.vue'));
Vue.component('TenantDataList', () => import('./components/customdata/TenantDataList.vue'));
Vue.component('SimpleQuoteSheetBuilder', () => import('./components/quotesheets/SimpleQuoteSheetBuilder.vue'));

// used in sandbox: /testing-sandbox-mitchell/
Vue.component('QuillEditorFull', () => import('./components/QuillEditorFull.vue'));
Vue.component('FormDocs', () => import('./components/forms/docs/FormDocs'));
Vue.component('FormDocsSandbox', () => import('./components/forms/docs/FormDocsSandbox'));
Vue.component('SnippetManager', () => import('./components/snippets/SnippetManager'));
Vue.component('FishboneDiagram', () => import('./components/demo-workflow/FishboneDiagram.vue'));
Vue.component('FlowBuilder', () => import('./components/flows/builder/FlowBuilder.vue'));
Vue.component('HqEmailTenantAdmins', () => import('./components/hq/HqEmailTenantAdmins.vue'));
Vue.component('BulkVendorFileManager', () => import('./components/vendors/BulkVendorFileManager.vue'));
Vue.component('KpiTree', () => import('./components/performance/KpiTree.vue'));
Vue.component('KpiTreeX6', () => import('./components/performance/KpiTreeX6.vue'));
Vue.component('ProductPriceAnalysis', () => import('./components/items/priceAnalysis/ProductPriceAnalysis.vue'));
Vue.component('RfxProductPriceAnalysis', () => import('./components/items/priceAnalysis/RfxProductPriceAnalysis.vue'));
Vue.component('RfxSmartFormAnalysis', () => import('./components/rfx_internal/RfxSmartFormAnalysis.vue'));
Vue.component('TuEmailIssuesManager', () => import('./components/tenant_users/TuEmailIssuesManager.vue'));
Vue.component('EmailIssuesSettingsForm', () => import('./components/settings/EmailIssuesSettingsForm.vue'));
Vue.component('TenantHqTenantUserList', () => import('./components/hq/TenantHqTenantUserList.vue'));
Vue.component('AuditLogAdmin', () => import('./components/auth/auditlog-admin/AuditLogAdmin.vue'));
Vue.component('AuthenticationAdmin', () => import('./components/auth/authentication-admin/AuthenticationAdmin.vue'));
Vue.component('AuthorizationAdmin', () => import('./components/auth/authorization-admin/AuthorizationAdmin.vue'));
Vue.component('FlowObjectCompare', () => import('./components/analytics/FlowObjectCompare.vue'));
Vue.component('CompItemManage', () => import('./components/compliance/comp_item/CompItemManage.vue'));
Vue.component('TipTapEditor', () => import('@/components/shared/TipTapEditor.vue'));  // not ready yet... but for testing
Vue.component('HqComplianceUploader', () => import('@/components/hq/HqComplianceUploader.vue'));  // for testing tenant compliance uploader
Vue.component('TierSupplierData', () => import('./components/items/tierSuppliers/TierSupplierData.vue'));  // Tier N supplier data -- PoC, not productized yet
Vue.component('TierSupplierGrid', () => import('./components/items/tierSuppliers/TierSupplierGrid.vue'));  // Tier N supplier data, AG-Grid treeData version -- PoC, not productized yet
Vue.component('TierSupplierChart', () => import('./components/items/tierSuppliers/TierSupplierChart.vue'));  // Tier N supplier data, X6 org-chart view -- PoC, needs X6 script tags on the page

/*
// TESTING TENANT CUSTOM IMPORTS
const tenantDir = 'nifco';
import * as nifcoComponents from './custom/nifco/components.js';

for (const customCompName in nifcoComponents) {
    const fullCompName = `${tenantDir}${customCompName}`;
    // SYNC LOADING:  
    // Vue.component(customCompName, nifcoComponents[customCompName])
    // ASYNC LOADING:
    Vue.component(
        fullCompName,  // with the prefix
        () => import(`./custom/${tenantDir}/${customCompName}.vue`)
    )
}
*/

/* import { asyncComponentMap } from './async-components.js';
Object.entries(asyncComponentMap).forEach(([asyncCompName, importPath]) => {
    Vue.component(asyncCompName, () => import(`${importPath}`));  // import() with a variable gives a warning...
}); */

// =====  Vue Formulate  ========
import VueFormulate from '@braid/vue-formulate';
import formulateConfig from './js/formulate-config';

Vue.use(VueFormulate, formulateConfig);

// ====== YOUR EXTRA JS FILES =======
// you can export them here, then set them as a constant / variable in your base template to make available globally
//import { justTestingVueBundle as justTesting } from './js/js-bundle-test.js';
import {
  suppliosApi as api,
  splAxiosText as htmlApi,
  splAxiosBare as axiosInstance,
  //splAxios,
  //suppliosHqApi as hqApi
  //suppliosApiNew,
} from './js/api-service.js';
import * as filtersHelpers from './js/filters-helpers';
import * as numberUtils from './js/utils/numberUtils';
import * as moneyUtils from './js/utils/moneyUtils';
import * as dtUtils from './js/utils/dtUtils';
import { DateTime as luxonDateTime } from 'luxon';

export default {
  //justTesting,
  api,
  htmlApi,
  axiosInstance,
  filtersHelpers,
  numberUtils,
  moneyUtils,
  dtUtils,
  nanoid,  // for generating random IDs on front-end outside of Vue components
  luxonDateTime,
  HelpscoutHelper, // must instantiate on client side and set instance on window
  //hqApi,
  //splAxios,
  //suppliosApiNew,
  setupVueI18n,  // for creating the i18n instance with common messages -- must be called on each page load and passed to the Vue instance when created
};
// exports will be accessible on something like window.suppliosBundle.exportName....

// ======= RANDOM STUFF =======
//Vue.config.productionTip = false

// THIS SEEMS TO WORK BUILDING AS A LIBRARY, EVEN WITHOUT EXPORT OF ANYTHING.... YOU HAVE SOMETHING SET IN VUE.CONFIG.JS FOR THIS

// No need to instantiate Vue instance... you'll do this on each page where you use Vue
/*
new Vue({
  render: h => h(App),
}).$mount('#app')
*/
